import { render, staticRenderFns } from "./CompaniesTypes.vue?vue&type=template&id=2c6a07fd&scoped=true"
import script from "./CompaniesTypes.vue?vue&type=script&lang=js"
export * from "./CompaniesTypes.vue?vue&type=script&lang=js"
import style0 from "./CompaniesTypes.vue?vue&type=style&index=0&id=2c6a07fd&prod&lang=scss&scoped=true"
import style1 from "./CompaniesTypes.vue?vue&type=style&index=1&id=2c6a07fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a07fd",
  null
  
)

export default component.exports